<template>
  <div>
    <el-container>
      <!--:default-active="this.$router.path"-->
<!--      <div class="head-class">-->
<!--        <a style="float: right;cursor:pointer;" @click="onLoginOut()">退出</a>-->
<!--      </div>-->
<!--      <el-header class="headerClass">-->
<!--        <div class="el-menu&#45;&#45;margin-left">-->
<!--          <el-menu-->
<!--            :default-active="activeIndex2"-->
<!--            router-->
<!--            class="el-menu-demo"-->
<!--            mode="horizontal"-->
<!--            @select="handleSelect"-->
<!--            background-color="#387af6"-->
<!--            text-color="#fff"-->
<!--            active-text-color="#ffd04b"-->
<!--          >-->
<!--            <el-menu-item index="/home">首页</el-menu-item>-->
<!--            <el-submenu index="2">-->
<!--              <template slot="title">快速下单</template>-->
<!--              <el-menu-item index="/quickOrders">客户下单</el-menu-item>-->
<!--              <el-menu-item index="/quickOrdersQuery">查询</el-menu-item>-->
<!--            </el-submenu>-->
<!--            <el-submenu index="3">-->
<!--              <template slot="title">代客下单</template>-->
<!--              <el-menu-item index="/clientOrders">业务员下单</el-menu-item>-->
<!--              <el-menu-item index="/clientOrdersQuery">查询</el-menu-item>-->
<!--            </el-submenu>-->
<!--            <el-menu-item index="/placeOrders">传统下单</el-menu-item>-->
<!--          </el-menu>-->

<!--        </div>-->

<!--      </el-header>-->
    </el-container>
  </div>
</template>


<script scoped>
export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
    };

  },
  methods: {
    handleSelect(){

    },
    onLoginOut(){
      this.$router.push("/");
      sessionStorage.removeItem("USERINFO");
    }
  },
  mounted() {

  }
}
</script>

<style ang="less" scoped>
.headerClass{
  background-color: #387af6;
  margin-top: 1%;
}
.el-menu--margin-left{
  margin-left: 15%;
}

.el-menu-item {
  width: 240px;
}
.el-submenu{
  width: 240px;
}
.head-class{
  background-color: #B0B0B0;
}
</style>



// WEBPACK FOOTER //
// src/components/component/header.vue